'use client';

function extractMessage(error: unknown): string {
  if (typeof error === 'string') return error;
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message;
  }
  return '';
}

export function fieldErrorId(fieldName: string): string {
  return `${fieldName}-error`;
}

export function FieldError({
  errors,
  fieldName,
}: {
  errors: unknown[];
  fieldName: string;
}) {
  if (errors.length === 0) return null;
  const message = extractMessage(errors[0]);
  if (!message) return null;
  return (
    <p
      id={fieldErrorId(fieldName)}
      className="mt-1 text-sm text-red-600"
      role="alert"
    >
      {message}
    </p>
  );
}
